export default "/images/vendor/flag-icon-css/flags/4x3/mf.svg?2d96a80bd05aca4ef7119716fad0fe64";